import styled from "styled-components";

export const Box = styled.div`
  padding: 16px;

  .controls {
    display: flex;
    gap: 16px;
    align-items: center;
    flex-wrap: nowrap;
    width: 100%;
    min-width: 0;
  }
`;

export const MenuBtn = styled.button`
  border: none;
  border-radius: 8px;
  min-width: max-content;
  background: #24274680 !important;
  display: flex;
  align-items: center;
  font-family: var(--font-family-golos) sans-serif;
  font-size: 16px;
  font-weight: 500;
  color: #d2eaff80;
  padding: 10px 16px;
  line-height: normal;
  font-style: italic;
  font-weight: 600;
  cursor: pointer;
  text-transform: uppercase;
  height: 50px;
  span {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  &[aria-expanded="true"] img {
    transform: rotate(180deg);
  }

  img {
    transition: 0.3s transform ease-in-out;
  }

  .icon {
    width: 26px;
    height: 26px;
    background: #e9f4ff0d;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
`;

export const RootTable = styled.table`
  border-collapse: separate;
  border-spacing: 0 5px;
  width: 100%;

  div.root-td:nth-child(1) {
    width: 30%;
  }
  div.root-td:nth-child(2) {
    width: 10%;
  }
  div.root-td:nth-child(3) {
    width: 10%;
  }
  div.root-td:nth-child(4) {
    width: 10%;
  }
  div.root-td:nth-child(5) {
    width: 10%;
  }
  div.root-td:nth-child(6) {
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  div.root-td:nth-child(7) {
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  div.root-td:nth-child(8) {
    margin-left: auto;
    width: auto;
    display: flex;
    justify-content: flex-end;
  }

  .root-td,
  td.root-td {
    padding: 10px 16px;
    text-align: left;
    overflow: hidden;
  }

  .root-tr td:last-child {
    text-align: center;
  }

  tr.root-tr > td:last-child {
    text-align: right;
  }

  div.root-tr {
    display: flex;
    align-items: center;
  }

  div.root-td {
    text-align: left;
  }

  thead .root-tr {
    font-weight: 600;
    color: #d2eaff80;
  }

  thead div.root-td:nth-child(6),
  thead div.root-td:nth-child(7),
  thead div.root-td:nth-child(8) {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .root-tbody tr {
    background-color: #151c2c;
  }

  .root-tr {
    border-collapse: collapse;

    > td:last-child {
      border-radius: 0 8px 8px 0;
    }

    > td:first-child {
      border-radius: 8px 0 0 8px;
    }
  }

  .collapse {
    padding: 0;
    width: 26px;
    height: 26px;
    background: #e9f4ff0d;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: none;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    img {
      transition: 0.3s transform ease-in-out;
    }

    &[aria-expanded="true"] img {
      transform: rotate(180deg);
    }
  }
`;

export const TableBox = styled.div`
  margin: 20px 0 40px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  list-style: none;
  padding: 0;

  .center {
    display: flex;
    justify-content: center;
  }
`;

export const ButtonsBox = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;

  button {
    padding: 8px 20px;
    border: 0;
    cursor: pointer;
    user-select: none;
    font-family: var(--font-family-golos), sans-serif;
    font-weight: 600;
    border-radius: 6px;

    &:disabled {
      opacity: 0.5;
    }
  }

  .small {
    padding: 4px 6px;
  }

  .warn {
    background-color: #ff9800;
    color: #e9f4ff;
  }

  .red {
    background-color: #c84230;
    color: #e9f4ff;
  }

  .blue {
    background-color: #3b8be9;
    color: #e9f4ff;
  }

  .collapse {
    padding: 0;
    width: 26px;
    height: 26px;
    background: #e9f4ff0d;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;

    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }

    img {
      transition: 0.3s transform ease-in-out;
    }

    &[aria-expanded="true"] img {
      transform: rotate(180deg);
    }
  }
`;

export const UsersTableBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  list-style: none;
  padding: 12px 16px;

  .center {
    display: flex;
    justify-content: center;
  }

  .isBanned {
    td {
      border: 1px solid red;
    }

    td:not(:first-child),
    td:not(:last-child) {
      border-left: 0;
      border-right: 0;
    }

    td:first-child {
      border-left: 1px solid red;
    }
    td:last-child {
      border-right: 1px solid red;
    }
  }

  table {
    border-collapse: separate;
    border-spacing: 0 5px;

    td,
    .left {
      text-align: left;
    }

    td:last-child,
    .right {
      text-align: right;
    }

    td {
      font-size: 14px;
      padding: 6px 6px;
    }

    .control {
      width: 80px;
    }

    tbody tr {
      td {
        background-color: #1b253c;
      }
    }

    tr {
      border-collapse: collapse;

      td:last-child {
        border-radius: 0 8px 8px 0;
      }

      td:first-child {
        border-radius: 8px 0 0 8px;
      }
    }
  }
`;

export const BottomBox = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 16px;
  gap: 16px;

  .field-wrapper {
    flex-grow: 1;
  }
`;

export const TooltipInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  max-width: 300px;
  word-wrap: break-word;

  .red {
    color: #c84230;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .field-wrapper {
    flex-grow: 1;
  }

  button {
    padding: 8px 20px;
    border: 0;
    cursor: pointer;
    user-select: none;
    font-family: var(--font-family-golos), sans-serif;
    font-weight: 600;
    border-radius: 6px;

    &:disabled {
      opacity: 0.5;
    }

    &.red {
      background-color: #c84230;
      color: #e9f4ff;
    }

    &.blue {
      background-color: #3b8be9;
      color: #e9f4ff;
    }

    &.orange {
      background-color: #ff9800;
      color: #e9f4ff;
    }
  }
`;
